module.exports = __webpack_public_path__ + "static/media/3740.b23da893.jpg";